import api from "@services/api-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    loading: false,
    lista: []
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {
    SET_CIDADES_LOADING: (state, isLoading) => {
      state.cidade.loading = isLoading;
    },

    SET_CIDADES: (state, cidades) => {
      state.cidade.lista = cidades;
    }
  },

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    getCidade: state => () => {
      return state.cidade.lista;
    },

    getCidadeOptions: state => () => {
      return state.cidade.lista.map(cidade => {
        return {
          value: cidade.id,
          text: cidade.nome
        };
      });
    }
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {
    FETCH_CIDADES_ASYNC: function({ commit }, estado) {
      // Se ja esta buscando ou se ja foi carregado
      // if (state.cidades.loading || state.cidades.lista.length > 0) return;
      commit("SET_CIDADES_LOADING", true);
      return new Promise((resolve, reject) => {
        api()
          .get(`estados/${estado.uf}`)
          .then(response => {
            if (response.data.status) {
              resolve(response.data.data.cidades);
            } else {
              throw Error();
            }
          })
          .catch(error => reject(error))
          .finally(() => commit("SET_CIDADES_LOADING", false));
      });
    }
  }
};

export default store;
